import cloneDeep from 'lodash/cloneDeep';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';
import { baseAction, changeLanguageAction } from 'store/actions';
import { buildAppState, LANGUAGE_PAYLOADS, type Language } from 'store/state';
import type { EntityProcessInfo } from 'types';

export const DEFAULT_RELATIONS = {
	children: [] as EntityProcessInfo[],
	companies: [] as EntityProcessInfo[],
	person: {} as EntityProcessInfo
};

export function useTopBar() {
	const ctx = useContext(AppContext);
	const { config, flowType, entityType, dispatch, navigate, getRelations, http, state } = ctx;
	const { language } = state.language;

	const logout = () => {
		const payload = { ...buildAppState(), language: cloneDeep(state.language) };
		dispatch([baseAction, payload]);
	};

	const changeLanguage = () => {
		const languages = Object.keys(LANGUAGE_PAYLOADS) as Language[];
		const nextLang = languages.indexOf(language) + 1;
		const key = languages[nextLang] || languages[0];
		dispatch([
			changeLanguageAction,
			{
				language: {
					...state.language,
					...LANGUAGE_PAYLOADS[key]
				}
			}
		]);
	};

	const resetProcesses = () => {
		const { API } = config;
		const { children, companies, person } = getRelations();

		const items = [...children, ...companies, person].map(x => {
			const id = x.processInfo?.agreementProcessId;
			return id ? http.delete(`${API.deleteProcess}/${id}`) : Promise.resolve();
		});

		Promise.all(items)
			.catch(console.log)
			.finally(() => navigate(`/${flowType}/${entityType}/onboard`));
	};

	return {
		...ctx,
		isLogged: !!state.user.token,
		logout,
		changeLanguage,
		resetProcesses
	};
}
